<template>
  <!-- <main
    role="main"
    class="vtd-main-section"
    :style="{
      backgroundImage:
        'url(https://cdn.trailfinders.com/hy50gj7p6n_bg-viewtrail.jpg)',
    }"
  > -->
  <main
    role="main"
    class="vtd-main-section"
    :style="{ backgroundColor: '#fff' }"
  >
    <MenuBar />
    <article class="vtd-section-info">
      <slot />
    </article>
    <LoadingSpinner />
  </main>
</template>

<script>
import MenuBar from "@/modules/menu-bar";
import LoadingSpinner from "@/partials/spinner";
export default {
  components: {
    MenuBar,
    LoadingSpinner,
  },
};
</script>

<style>
@import "./styles.scss";
</style>
